import editableMultipleFields from "./editableMultipleFields.component";

const editableMultipleFieldsModule = angular
  .module("app.components.editableMultipleFields", [])
  .component("editableMultipleFields", editableMultipleFields);

export default editableMultipleFieldsModule;



// WEBPACK FOOTER //
// ./src/components/editableMultipleFields/editableMultipleFields.module.js